// extracted by mini-css-extract-plugin
module.exports = {"img1":"RecipeDetail_img1__2pRTB","img2":"RecipeDetail_img2__3w-LV","img3":"RecipeDetail_img3__3Jxq1","recipeDetailContainer":"RecipeDetail_recipeDetailContainer__1DyH8"};